import React from 'react';

import { SLOT_FAMILY_CORRECT_SCORE_SINGLE_BET } from 'app/constants/matchCenterStakes';

import CorrectScore from './CorrectScore';
import DefaultSlotContentComponent from './DefaultSlotContentComponent';

// ---

// TODO: write types, if you have some free time please :)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyType = any;

export function getSlotContentComponent(
  slotFamily: AnyType,
  stakes: AnyType,
  slotStakeDataGaEvent: string,
) {
  switch (slotFamily) {
    case SLOT_FAMILY_CORRECT_SCORE_SINGLE_BET:
      return (
        <CorrectScore stakes={stakes}
                      slotStakeDataGaEvent={slotStakeDataGaEvent} />
      );
    default:
      return (
        <DefaultSlotContentComponent stakes={stakes}
                                     slotStakeDataGaEvent={slotStakeDataGaEvent} />
      );
  }
}
